import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function IntroducingGuide() {
  const items = ['The hidden relationship between sugar and oral bacteria', 'Why some foods may affect your teeth differently than others', 'The common nighttime habit many people overlook', 'Daily practices that may support a healthier oral environment', 'Natural strategies for maintaining strong teeth and healthy gums'];
  return <section className="py-20 bg-white" data-id="element-146">
      <div className="max-w-5xl mx-auto px-6" data-id="element-147">
        {/* Introducing */}
        <div className="bg-sky-50 rounded-3xl p-8 md:p-12" data-id="element-148">
          <div className="text-center mb-8" data-id="element-149">
            <span className="inline-block bg-sky-500 text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-150">
              Introducing
            </span>
            <h3 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-3" data-id="element-151">
              The Dental Sugar Hack
            </h3>
            <p className="text-slate-600" data-id="element-152">
              A simple digital guide that explains:
            </p>
          </div>

          <ul className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-153">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start bg-white rounded-xl p-4 shadow-sm" data-id="element-154">
                <div className="w-6 h-6 rounded-full bg-sky-100 flex items-center justify-center mr-3 shrink-0 mt-0.5" data-id="element-155">
                  <CheckIcon size={14} className="text-sky-600" strokeWidth={3} data-id="element-156" />
                </div>
                <span className="text-slate-700 text-sm" data-id="element-157">{item}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-8" data-id="element-158">
            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 shadow-lg" data-id="element-159">
              Yes! I Want Access
            </button>
          </div>
        </div>

        {/* What makes this different */}
        <div className="mt-16 max-w-3xl mx-auto text-center" data-id="element-160">
          <h3 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-6" data-id="element-161">
            What Makes This Different?
          </h3>
          <div className="space-y-4 text-slate-600 text-lg leading-relaxed" data-id="element-162">
            <p data-id="element-163">Most dental advice focuses on cleaning your teeth.</p>
            <p data-id="element-164">This guide explores something different:</p>
            <p className="font-semibold text-sky-600 text-xl" data-id="element-165">
              Your oral microbiome.
            </p>
            <p data-id="element-166">
              Inside you'll discover how maintaining a balanced oral environment
              may play an important role in supporting long-term dental
              wellness.
            </p>
            <p data-id="element-167">
              This educational guide reveals practical insights in a simple,
              easy-to-follow format.
            </p>
          </div>
        </div>
      </div>
    </section>;
}